<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Attention!</h1>

  <div class="change-subscription-modal">
    <p class="change-subscription-modal__body">
      You are changing subscription

      <span class="change-subscription-modal__subject">
        from "{{ fromSubject }}" to "{{ toSubject }}"
      </span>
    </p>

    <p class="change-subscription-modal__question">Are you confirming the change of subscription?</p>

    <div class="change-subscription-modal__actions">
      <button class="btn_secondary btn_lg" (click)="onClose()">No</button>
      <button class="btn_primary btn_lg" (click)="onSubmit()">Yes</button>
    </div>
  </div>
</app-base-modal>
